import Backbone from "backbone";
import {pathname} from "../../common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";
import {NO_CONTENT, NOT_FOUND, OK} from "../../api/HTTPStatus";

export default Backbone.View.extend({

    selectors: {
      msgActive: ".js-CheckoutActive",
      msgSuccess: ".js-CheckoutSuccess",
      msgFailed: ".js-CheckoutFailed",
      checkoutLink: ".js-CheckoutLink"
    },

    events: {
      "click .js-CheckoutLink": "confirmMembership",
    },

    confirmMembership: function () {
      var that = this;
      SharedDispatcher.trigger("overlay:show");
      $.ajax({
        type: "POST",
        // TODO move to account configuration
        url: pathname + '/account/api/v1/membership/attachsubscription',

        statusCode: {
          [OK]: function () {
            SharedDispatcher.trigger("overlay:hide");
            $(that.selectors.checkoutLink).remove();
            $(that.selectors.msgSuccess).removeClass("hide");
          },
          [NO_CONTENT]: function () {
            SharedDispatcher.trigger("overlay:hide");
            $(that.selectors.checkoutLink).remove();
            $(that.selectors.msgActive).removeClass("hide");
          },
          [NOT_FOUND]: function () {
            SharedDispatcher.trigger("overlay:hide");
            $(that.selectors.msgFailed).removeClass("hide");
          }
        }
      });
    }

  });
